import { createStore, applyMiddleware, compose } from 'redux' // 3.7.2
import ReduxThunk from 'redux-thunk' // 2.2.0

import RootReducer from './modules/RootReducer'

export default createStore(RootReducer, {}, getCompose()(
  applyMiddleware(ReduxThunk)
))

function getCompose(){
  if(typeof(window) === 'undefined'){
    return compose
  }
  return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}



// WEBPACK FOOTER //
// ./src/state/Store.js